// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"eadd7b1d","31":"4473cdff","62":"2c7d92fc","74":"33f277a0","110":"c68386e0","205":"566acce7","264":"59bb465d","282":"067166fc","350":"84a0269b","369":"de50ea30","598":"d4a1cecd","631":"59616b56","716":"36d815b5","833":"f1383ce0","899":"81fb65a7"}[chunkId] + ".chunk.js";
};